module.exports = __webpack_public_path__ + "20cb1a7e1f2244607183d5bbb739f9f3.svg";